import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import EventItem from "../components/EventItem";
import { ImageType, SvgImage } from "../../../images/svg";

const useStyles = makeStyles((theme) => ({
  textLightBig: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "center",
    marginBottom: "12px",
  },
  box: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px 24px 0px 24px",
    flexDirection: "column",
  },
  button: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "12px 24px 12px 24px",
    border: "3px solid #efeff2",
    borderRadius: 10,
    flexDirection: "row",
  },
  buttonText: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "18px",
    fontWeight: 700,
    color: "#114668",
    marginLeft: "8px",
  },
  break: {
    width: "100%",
    height: "1px",
    marginBottom: "18px",
    marginTop: "18px",
    backgroundColor: "#bcbcbc",
  },
}));

const EventStatusListView = ({
  eventStatusList,
  eklok,
  onStopAllActionPress,
  onStopOnItemClick,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      {eventStatusList.length > 0 ? (
        <Box className={classes.box}>
          <Typography className={classes.textLightBig}>
            {t("mobile_frame.home.running_events")}
          </Typography>
          <Box className={classes.break} />
          <Box className={classes.button} onClick={onStopAllActionPress}>
            <SvgImage type={ImageType.StopMini} />
            <Typography className={classes.buttonText}>
              {t("mobile_frame.home.stopAll").toUpperCase()}
            </Typography>
          </Box>
          <Box className={classes.break} />
        </Box>
      ) : (
        <Box className={classes.box}>
          <Typography className={classes.textLightBig}>
            {t("mobile_frame.home.no_running_events")}
          </Typography>
          <Box className={classes.break} />
        </Box>
      )}
      {eventStatusList.map((event, index) => (
        <EventItem
          event={event}
          eklok={eklok}
          key={index}
          onStopOnItemClick={onStopOnItemClick}
        />
      ))}
    </>
  );
};

export default EventStatusListView;
